import { useNavigate } from '@tanstack/react-router';
import { ServerCrash } from 'lucide-react';
import { SystemMessageLayout } from '../ui/SystemMessageLayout';

export function InternalError({ error, reset }: { error?: Error; reset?: () => void }) {
  const navigate = useNavigate();

  return (
    <SystemMessageLayout
      statusCode={500}
      icon={<ServerCrash className="w-12 h-12 text-danger-500" strokeWidth={1.5} />}
      title="Unexpected Error"
      description={
        <span className="flex flex-col gap-2">
          <span>We've encountered a system error while processing your request. Our engineering team has been notified.</span>
          {error?.message && (
            <span className="text-xs font-mono text-text-muted bg-surface-2 p-2 rounded-md overflow-hidden text-ellipsis whitespace-nowrap max-w-full block">
              {error.message}
            </span>
          )}
        </span>
      }
      action={{
        label: reset ? 'Try Again' : 'Return to Dashboard',
        onClick: reset ? reset : () => navigate({ to: '/' }),
      }}
      {...(reset && {
        secondaryAction: {
          label: 'Return to Dashboard',
          onClick: () => navigate({ to: '/' }),
        },
      })}
    />
  );
}
